import React, { useState } from "react";
import CreateAccessType from "../AssetManagement/CreateAccessType";
import ApproveAccessTypeRequests from "../AssetManagement/ApproveAccessTypeRequests";
import { toggleMenu } from "../../utils/helpers";
import PageTitle from "../../components/PageTitle";

const NewAccessEnrollment = ({ title }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: "Create Access Type", component: CreateAccessType },
    {
      label: "Approve Access Type Request",
      component: ApproveAccessTypeRequests,
    },
  ];

  const ActiveComponent = tabs[activeTab].component;

  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} />
      </div>
      <div className="card p-3">
        <ul className="nav nav-tabs">
          {tabs.map((t, i) => (
            <li className="nav-item" key={i}>
              <button
                className={`nav-link ${activeTab === i ? "active" : ""}`}
                onClick={() => setActiveTab(i)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>

        <div>
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
};

export default NewAccessEnrollment;
